export default __webpack_public_path__ + "static/media/b-1.309bbe72.svg";